import { SuggestedCommodityCodeDto } from '@billing/app/api'
import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

interface Props {
  id?: string
  formId: string
  suggestedCode?: SuggestedCommodityCodeDto
}
export const CommodityFormHeader = observer(({ id, formId, suggestedCode }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action = id ? t('edit', 'Edit') : t('create', 'Create')

  const breadCrumbs: BreadcrumpItem[] = useMemo(() => {
    return [
      { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
      {
        label: t(PATHS.masterData.commoditiesAndPackaging.title),
        onClick: () => navigate(PATHS.masterData.commoditiesAndPackaging.url),
      },
      {
        label: action,
      },
    ]
  }, [t, action, navigate])

  return (
    <Header
      title={t('upsertCommodity', '{action} commodity', {
        action: action,
      })}
      subTitle={t('threePath:Path', 'Three path: {path}', {
        path: suggestedCode?.treePath ?? EmptyIndicator,
      })}
      breadcrumbs={breadCrumbs}
      position='relative'
      rightRenderOption={
        <>
          <Button
            variant='text'
            color='inherit'
            onClick={() => navigate(PATHS.masterData.commoditiesAndPackaging.url)}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            type='submit'
            form={formId}
            data-cy='commodity-save-btn'
          >
            {t('submit', 'Submit')}
          </Button>
        </>
      }
    />
  )
})
